import { ILoginFormLang } from '../../../types/lang'

export const loginFormLang: ILoginFormLang = {
	login_form: {
		field_user_name_label: 'Ім\'я користувача',
		field_user_name_placeholder: 'Ім\'я користувача',
		field_password_label: 'Пароль',
		field_password_placeholder: 'Пароль',
		msg_login_success: 'Ласкаво просимо, {{name}}!',
		btn_login: 'Увійти'
	}
}